import { useRef, useState } from "react";
import { Modal, Button } from "@etframework/ui.components";
import { useCreateTaxReturnTaskType } from "../../data/mutations/taskTypeMutations";
import { useTranslation } from "react-i18next";
import useModalEvent from "../../hooks/useModalEvent";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

export const CreateTaxReturnTaskTypeModal = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { mutate: createTaxReturnTaskType, isPending } =
    useCreateTaxReturnTaskType();
  const { t } = useTranslation(["TaskTypes"], {
    useSuspense: false,
  });

  const [boardId, setBoardId] = useState();

  //Modal
  const modalRef = useRef();
  const { ModalEvents, useRegisterEvent } = useModalEvent();
  const [showModal, setShowModal] = useState(false);

  const onModelBeforeClose = () => {};

  const onModalClose = () => {
    setShowModal(false);
  };

  const closeModal = () => {
    setShowModal(false);
    modalRef?.current?.close();
  };

  const openModal = () => {
    setShowModal(true);
    modalRef?.current?.open();
  };

  const toggleModal = (e) => {
    setBoardId(e.detail?.boardId);

    if (showModal) {
      closeModal();
      return;
    } else {
      openModal();
    }
  };

  const ModalContent = () => {
    const onCreateTaxReturnTaskType = () => {
      createTaxReturnTaskType(
        { boardId: boardId },
        {
          onSuccess: (response) => {
            queryClient.invalidateQueries(["get-task-types", boardId]);
            onModalClose();
            toast.success(t("CreateTaxReturnTaskTypeModal.Success"), {
              position: "bottom-left",
            });
            navigate(
              `/duedates/settings/boards/${boardId}/tasktypes/${response.Id}`
            );
          },
          onError: () => {
            toast.error(t("CreateTaxReturnTaskTypeModal.ErrorMsg"), {
              position: "bottom-left",
            });
          },
        }
      );
    };

    return (
      <div className="et-create-tax-return-task-type-modal">
        <div>
          <span className="create-tax-return-task-type-header d-block">
            {t("CreateTaxReturnTaskTypeModal.TaxReturnTaskTypeModalTitle")}
          </span>
        </div>

        <div>
          <span className="create-tax-return-task-type-content d-block">
            {t("CreateTaxReturnTaskTypeModal.TaxReturnTaskTypeModal1")}
          </span>
          <br />
          <span className="create-tax-return-task-type-content d-block">
            {t("CreateTaxReturnTaskTypeModal.TaxReturnTaskTypeModal2")}
          </span>
        </div>

        <div className="d-flex justify-content-end create-tax-return-task-type-modal-btns gap-3">
          <Button
            text={t("Cancel")}
            className="btn-tertiary"
            onClick={closeModal}
          />
          <Button
            text={t("Confirm")}
            className="btn btn-primary"
            onClick={onCreateTaxReturnTaskType}
            loading={isPending}
          />
        </div>
      </div>
    );
  };

  useRegisterEvent(ModalEvents.CreateTaxReturnTaskTypeModal, toggleModal);

  return (
    <Modal
      id={ModalEvents.CreateTaxReturnTaskTypeModal.Id}
      ref={modalRef}
      isModal
      showCloseIcon={true}
      visible={showModal}
      content={<ModalContent />}
      close={onModalClose}
      beforeClose={onModelBeforeClose}
      minHeight="20vh"
      width="500px"
    ></Modal>
  );
};
